// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-q_fm","galleryItem_borderTopRadius":"c-q_fn","galleryItem__image":"c-q_fo"};